<template>
  <section>
    <h4>Booker Payments</h4>
    <div class="row my-4 px-2">

      <!-- filtros -->
      <div class="col-md-12 px-0">
        <div class="container-fluid w-100 mb-3 p-3 border bg-white rounded stats-wrapper">
          <div class="d-flex flex-wrap">
            <div class="w-50 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">From</span>
              </div>
              <date-picker id="startDatePicker" class="form-control" v-model="filtersPage.range.startDate"
                :config="datePickerConfig" placeholder="Start Date"></date-picker>

              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">To</span>
              </div>
              <date-picker id="startDatePicker" class="form-control" v-model="filtersPage.range.endDate"
                :config="datePickerConfig" placeholder="Start Date"></date-picker>
            </div>

            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper" v-if="!isBdrUser()">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">BDR</span>
              </div>
              <treeselect v-model="filtersPage.bdr_user_id" :options="bdr_users" :multiple="false" :clearable="false"
                :normalizer="normalizeOptions" class="form-control inline-table" @change="getData">
              </treeselect>
            </div>

            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper" v-if="!isBdrUser()">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">{{ $t("lang.label.payment_status") }}</span>
              </div>
              <select v-model="filtersPage.payment_status_id" class="form-control">
                <option :value="0">Touts</option>
                <option :value="2">Paid</option>
                <option :value="1">Pending</option>
              </select>
            </div>

            <button class="btn btn-success ml-3 mt-1" @click="loadRangeStats()" style="width: 20%" :disabled="loading">
              <i class="icon-calendar-check-o mr-2"></i>
              <small>
                {{ $t("lang.button.filter") }}
              </small>
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-center w-100" v-if="loading">
        <LoadingSpinner></LoadingSpinner>
      </div>

      <!-- paginacion y totales -->
      <div class="col-md-12 w-100 my-2 card px-2" v-if="!loading">
        <div class="row my-2" v-if="!isBdrUser()">
          <div class="col-md-12">
            <span class="mr-1">{{ $t("lang.label.results") }}:</span>
            <small v-if="total < 0" class="ml-1 text-primary mr-4">{{ $t("lang.search.calculating") }}...</small>
            <strong class="mr-5" v-else>{{ total }}</strong>
            <div class="row">
              <div class="col-md-5">
                <span class="mr-1">{{ $t("lang.column.salary_total") }}:</span>
                <small v-if="salaryTotal < 0" class="ml-1 text-primary mr-4">{{ $t("lang.search.calculating")
                }}...</small>
                <strong class="mr-5" v-else>€ {{ salaryTotal }}</strong>
                <button class="ml-2 btn btn-sm btn-primary" @click="getToDownload()" :disabled="processingAllItems">
                  <span v-if="!processingAllItems">
                    Download csv
                  </span>
                  <span v-else>Processing...</span>
                </button>
              </div>
              <div class="col-md-7">
                <Pagination :total="total" :totalpage="totalPageStep" :model="pagination" :limit="false"
                  :color="'primary'" @changePage="getData" key="paginationkey"></Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabla de datos -->
      <div class="col-md-12 w-100 my-2 card p-2" v-if="!loading">

        <div class="mx-0 px-0 table-responsive">
          <Table class="mx-2 w-100" :headers="headers" :cols="cols" :data="payments" :checkbox="false" :notselect="true"
            :model="model" :fieldsLoading="fieldsLoading" :key="100" @goToUser="goToUser"
            @changeStatusPayment="changeStatusPayment($event)" @addSales="addSales($event)"
            @downloadInvoice="openInvoiceModal($event)">
          </Table>
        </div>
      </div>
    </div>

    <Modal :name="'sales'" height="auto" width="80%">
      <!-- Form data user   -->
      <div>
        <div class="p-4 text-center">
          <label>
            <h4>{{ $t("lang.label.change_number_meetings") }}</h4>
          </label>
        </div>
        <div class="px-4 pb-4 text-center">
          <div class="form-group">
            <input type="number" min="0" class="form-control-sm" required="true" placeholder="Meetings"
              v-model="NumberMeetings" />
            <div class="d-flex justify-content-center mt-4">
              <button class="btn btn-primary mx-3" type="submit"
                @click="changeMeetingsBooked(UserMeetingId, NumberMeetings)">
                {{ $t("lang.button.save") }}
              </button>
              <button class="btn btn-danger mx-3" @click="close()">
                {{ $t("lang.button.cancel") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <div style="opacity:0; position:relative; pointer-events:none;">
      <Modal :name="'invoice-pdf'" @opened="onInvoiceModalOpened">
        <!-- <-- cambiar ref del componente por un wrapper DOM con ref -->
        <div ref="pdfContent">
          <BookerInvoice :invoice="invoiceToDownload" />
        </div>
      </Modal>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  bookersService,
  usersService,
} from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import BookerInvoice from "./BookerInvoice.vue";
import { pdfTermsAndConditionsMixin } from "@/_mixins/pdfTermsAndConditionsMixin.js";

const PAPAYA_CSV_HEADERS = [
  ["beneficiary", "entity", "entity", "entity", "payment_info", "payment_info", "payment_info", "payment_info"],
  ["id", "first_name", "last_name", "company_name", "amount", "currency", "payment_type", "correlation"],
];
const PAPAYA_PAYMENT_TYPE = "";

export default {
  name: "BookerPayments",
  mixins: [pdfTermsAndConditionsMixin],
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
    ordersPreparingAndNotVerified() {
      return this.ordersStatus.filter(
        (el) => el.target_status_id === "1" && el.target_validation === "0"
      );
    },
    ordersPreparingAndVerified() {
      return this.ordersStatus.filter(
        (el) =>
          el.target_status_id === "1" &&
          el.target_validation === "1" &&
          parseInt(el.prospectors_active) > 3
      );
    },
    isBookerManager() {
      return this.currentUser.role_id == 9;
    },
    totalPageStep() {
      return this.payments.length;
    },
  },
  data() {
    return {
      processingAllItems: false,
      invoiceToDownload: null,
      btnLoading: false,
      orderDirection: "desc",
      datePickerConfig: {
        format: "YYYY-MMM",
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MMM",
        viewMode: "months",
        useCurrent: false,
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      total: -1,
      salaryTotal: 0,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      filtersPage: {
        bdr_user_id: null,
        payment_status_id: 0,
        range: {
          startDate: moment().subtract(1, "month").format("YYYY-MMM"),
          endDate: moment().format("YYYY-MMM"),
        },
      },
      lastFilterPage: [],
      payments: [],
      bdr_users: null,
      orderBy: "meetings_rate",
      UserMeetingId: null,
      NumberMeetings: 0,
      filters: [],
      filterkey: 2233,
      ordersStatus: [],
      fieldsLoading: true,
      sort: "",
      dir: "",
      keyFilter: 1,
      searchFilter: {},
      oldQuery: "  ",
      orderStatus: 10,
      loading: true,
      typelist: 10,
      typelistPreparing: 10,
      filterColumn: [],
      showEmptyImage: false,
      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "rk_number",
          },
        ],
        [
          {
            value: "avatar",
            type: "image",
            width: "25px",
          },
        ],
        [
          {
            value_label: "name",
            value_emit: "user_id",
            class: "text-primary",
            type: "emit",
            emit: "goToUser",
          },
        ],
        [
          {
            value: "account_holder_name",
          },
        ],
        [
          {
            value: "invoicing_period",
          },
        ],
        [
          {
            value: "meetings_booked",
          },
        ],
        [
          {
            value: "meetings_booked",
          },
          {
            // value: "payment_status",
            // value_emit: "id",
            // value_if: "Pending",
            // icon: "fa fa-edit",
            // class: "btn btn-sm btn-warning ml-5 px-2",
            // type: "emit",
            // emit: "addSales",
          },
        ],
        [
          {
            value: "current_consistency",
            format: "percentage",
          },
        ],

        [
          {
            value: "adapted_fixed_salary",
            format: "money",
            simbol: "€",
          },
        ],
        [
          {
            value: "commission_meeting",
            format: "money",
            simbol: "€",
          },
        ],
        [
          {
            value: "commissions",
            format: "money",
            simbol: "€",
          },
        ],
        [
          {
            value: "abs_commission_total",
            format: "money",
            simbol: "€",
          }
        ],
        [
          {
            value: "value_cooptation_final",
            format: "money",
            simbol: "€",
          }
        ],
        [
          {
            value: "final_salary",
            format: "money",
            simbol: "€",
            tooltip_value: "salary_degrasivity",
            tooltip_icon: "fa-question-circle",
          },
          {
            type: "icon",
            class: "d-flex icon-download  mr-2",
            type2: "emit",
            emit: "downloadInvoice",
          }
        ],
        [
          {
            value: "payment_status",
            value_label: "payment_status",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: "Pending",
                label: "Pending",
                bgColor: "#ffc107",
                textColor: "#FFFFFF",
              },
              {
                id: "Paid",
                label: "Paid",
                bgColor: "#5054EB",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "payment_status",
            label: "Pay",
            value_emit: "id",
            value_if: "Pending",
            class: "btn btn-sm btn-success px-2",
            type: "emit",
            emit: "changeStatusPayment",
          },
        ],
        [
          {
            value: "booker_salary",
            format: "money",
            simbol: "€",
          },
        ],
        [
          {
            value: "booker_revenue_generated",
            format: "money",
            simbol: "€",
          },
        ],
        [
          {
            value: "booker_gross_margin",
            format: "percentage",
          },
        ],
      ],
      headers: [
        {
          label: "RK",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Photo",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Name",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Account Holder",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Invoicing period",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Attended meetings", //booker view of the reunion column
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Attended meetings", //admin view of the reunion column
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling"],
          id: 1,
        },
        {
          label: "Consistency",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Adapted fixed salary",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling"],
          id: 2,
        },
        {
          label: "Commision on meeting",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },
        {
          label: "Commisions",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },
        {
          label: "Comissions ABS",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },
        {
          label: "Cooptation",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },
        {
          label: "Final salary",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Status",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Action",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling"],
          id: 1,
        },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
      paymentsAllItems: [],
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Treeselect,
    Pagination,
    BookerInvoice
  },
  created() {
    this.getUserBdr();
    this.getData();
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),

    getToDownload() {
      const allItems = 1; // cuando quieres pedir todos los resultados sin limite
      this.getData(allItems);
    },

    escapeCsvValue(value) {
      const normalizedValue = value !== undefined && value !== null ? value : "";
      return `"${String(normalizedValue).replace(/"/g, '""')}"`;
    },

    download() {
      const nameDocument = "report-booker-payments.csv";
      const paymentsWithPositiveSalary = this.paymentsAllItems.filter(item => Number(item.final_salary) > 0);

      if (paymentsWithPositiveSalary.length === 0) {
        this.$swal({
          type: "warning",
          title: "No payments to export",
          text: "There are no booker payments with a final salary greater than zero for the selected period.",
          showCancelButton: false,
        });
        return;
      }

      const paymentsWithoutBeneficiaryId = paymentsWithPositiveSalary.filter(
        item => !String(item.papaya_beneficiary_id || "").trim()
      );
      const paymentsToExport = paymentsWithPositiveSalary.filter(
        item => String(item.papaya_beneficiary_id || "").trim()
      );

      if (paymentsToExport.length === 0) {
        const missingBookers = paymentsWithoutBeneficiaryId
          .slice(0, 10)
          .map(item => item.name || `Booker #${item.user_id}`)
          .join(", ");
        const remainingBookers = paymentsWithoutBeneficiaryId.length - 10;
        const remainingMessage = remainingBookers > 0 ? ` and ${remainingBookers} more` : "";

        this.$swal({
          type: "error",
          title: "No valid payments to export",
          text: `All payments were omitted because they are missing a Papaya Beneficiary ID: ${missingBookers}${remainingMessage}.`,
          showCancelButton: false,
        });
        return;
      }

      const rows = paymentsToExport.map(item => [
        String(item.papaya_beneficiary_id).trim(),
        item.first_name,
        item.last_name,
        "",
        item.final_salary,
        "EUR",
        PAPAYA_PAYMENT_TYPE,
        item.id,
      ].map(this.escapeCsvValue).join(","));

      const headerRows = PAPAYA_CSV_HEADERS.map(headers => headers.join(","));
      const csv = [...headerRows, ...rows].join("\r\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", nameDocument);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      if (paymentsWithoutBeneficiaryId.length > 0) {
        const missingBookers = paymentsWithoutBeneficiaryId
          .slice(0, 10)
          .map(item => item.name || `Booker #${item.user_id}`)
          .join(", ");
        const remainingBookers = paymentsWithoutBeneficiaryId.length - 10;
        const remainingMessage = remainingBookers > 0 ? ` and ${remainingBookers} more` : "";

        this.$swal({
          type: "warning",
          title: "CSV exported with omitted payments",
          text: `${paymentsWithoutBeneficiaryId.length} payment(s) without a Papaya Beneficiary ID were omitted: ${missingBookers}${remainingMessage}.`,
          showCancelButton: false,
        });
      }
    },
    isBdrUser() {
      return (
        this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2
      );
    },

    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },

    getUserBdr() {
      usersService
        .getBdrs()
        .then((res) => {
          this.bdr_users = res.result;
        })
        .catch((err) => consolelog(err));
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    adaptedMonth(filterMonth) {
      const monthMap = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
      };

      const parts = filterMonth.split("-");
      const year = parts[0];
      const month = monthMap[parts[1]];
      return `${year}-${month}`;
    },
    validarDate() {
      let startDate = new Date(this.filtersPage.range.startDate);
      let endDate = new Date(this.filtersPage.range.endDate);
      if (startDate.getTime() > endDate.getTime()) {
        return true;
      } else {
        return false;
      }
    },
    loadRangeStats() {
      if (this.validarDate() === true) {
        this.$swal({
          type: "warning",
          title: "Error!",
          text: "Start date should be less than end date. ",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Close",
        });
      } else {
        this.pagination.cantPerPage = 25;
        this.pagination.currentPage = 1;
        this.getData();
      }
    },

    changeMeetingsBooked(id, meeting_booked) {
      if (this.NumberMeetings === null || this.NumberMeetings === "") {
        this.$swal({
          type: "error",
          title: "This field is required",
          text: "field null or empty, try again.",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      this.$swal({
        type: "warning",
        title: "Change Meetings Booked",
        text: "Are you sure for change the meetings booked?",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: "Accept",
      }).then((result) => {
        if (result.value) {
          bookersService
            .updateMeetingBookers(id, meeting_booked)
            .then((response) => {
              if (response.status === 200) {
                this.$swal({
                  type: "success",
                  title: this.$t("lang.label.datasavedsuccessfully"),
                  text: this.$t("lang.label.emailSettingSuccessfully"),
                  showConfirmButton: false,
                  timer: 2500,
                });
                this.$modal.hide("sales");
                this.getData();
              } else {
                this.$swal({
                  type: "warning",
                  title: this.$t("lang.label.error"),
                  html: this.$t("lang.general.error"),
                  showConfirmButton: true,
                });
              }
            })
            .catch((error) => {
              this.$swal({
                type: "warning",
                title: this.$t("lang.label.error"),
                html: this.$t("lang.general.error"),
                showConfirmButton: true,
              });
            });
        }
      });
    },

    addSales(id) {
      const user = this.payments.find((user) => user.id == id);
      if (user) {
        this.UserMeetingId = user.id;
        this.NumberMeetings = user.meetings_booked;
      } else {
        this.NumberMeetings = 0;
      }
      this.$modal.show("sales");
    },

    close() {
      this.$modal.hide("sales");
    },

    async openInvoiceModal(booker) {
      // invoicePeriod puede venir en varios formatos:
      // - "YYYY-MM"  => tomamos todo el mes
      // - "YYYY-MM-DD / YYYY-MM-DD" => ya está el rango
      // - "YYYY-MM-DD" => usamos ese mes

      let user = await usersService.getUserById(booker.user_id).then((res) => {
        return res.user;
      });

      const invoicePeriod = booker.invoicing_period || '';

      let startDate;
      let endDate;

      if (invoicePeriod.includes('/')) {
        // ya tiene rango "YYYY-MM-DD / YYYY-MM-DD"
        const parts = invoicePeriod.split('/').map(p => p.trim());
        startDate = moment(parts[0], ['YYYY-MM-DD', 'YYYY-MM', 'YYYY-MMM']).format('YYYY-MM-DD');
        endDate = moment(parts[1], ['YYYY-MM-DD', 'YYYY-MM', 'YYYY-MMM']).format('YYYY-MM-DD');
      } else {
        // tratar como YYYY-MM o YYYY-MM-DD o formatos con texto
        const m = moment(invoicePeriod, ['YYYY-MM-DD', 'YYYY-MM', 'YYYY-MMM'], true);
        const base = m.isValid() ? m : moment(); // fallback al mes actual
        startDate = base.clone().startOf('month').format('YYYY-MM-DD');
        endDate = base.clone().endOf('month').format('YYYY-MM-DD');
      }

      const periodLabel = `${startDate} / ${endDate}`;
      let d = new Date(booker.invoicing_period);
      let year_digits = d.getFullYear().toString().substr(-2);
      let invoiceId = year_digits + 'MH' + booker.id.toString().padStart(10, "0");

      let items = [
        { date: periodLabel, description: "Outbound calling service", total: booker.adapted_fixed_salary },
        { date: periodLabel, description: `Commission (${booker.meetings_booked} attended meetings)`, total: booker.commissions }
      ];
      if (booker.abs_commission_total > 0) {
        items.push({ date: periodLabel, description: `Commission ABS (${booker.abs_meetings})`, total: booker.abs_commission_total })
      }
      if (booker.value_cooptation_final > 0) {
        items.push({ date: periodLabel, description: `Cooptation (${booker.coop_qty})`, total: booker.value_cooptation_final })
      }
      this.invoiceToDownload = {
        number: invoiceId,
        date: moment(booker.payment_status_updated).format('D MMMM, YYYY'),
        to: { name: "AIVONI SAS", address: "4, avenue Jean-Baptiste Clément\n92100 Boulogne Billancourt" },
        from: { name: user.bank_data.account_holder_name, address: user.bank_data.address, rib: user.bank_data.rib, bic: user.bank_data.bic, iban: user.bank_data.iban, city: user.bank_data.city, postal_code: user.bank_data.postal_code },
        rows: items,
        subtotal: booker.final_salary,
        vat: "0.00",
        total: booker.final_salary,
        notes: "This invoice was generated electronically..."
      };

      
      // return null
      this.$modal.show("invoice-pdf");
    },

    async onInvoiceModalOpened() {
      // espera un tick para asegurar render completo si hace falta
      await this.$nextTick();
      // lanzar el mixin para generar PDF; segundo parámetro 1 usa this.$refs.pdfContent
      await this.downloadTermsAndConditionsPDF(2, 1, 'invoice-' + this.invoiceToDownload.number + '.pdf');
      // cerrar modal tras la descarga
      this.$modal.hide("invoice-pdf");
    },

    changeStatusPayment(id) {
      this.$swal({
        icon: "warning",
        title: "Change status Payment",
        text: "Are you sure for change the status payment?",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: "Accept",
      }).then((result) => {
        if (result.value) {
          bookersService.bookerPaymentChangeStatus(id, 2).then((response) => {
            if (response.result === "ok") {
              const payment = this.payments.find((pay) => pay.id == id);
              if (payment) {
                payment.payment_status = "Paid";
                payment.payment_status_id = 2;
              }
              this.$swal({
                type: "success",
                title: this.$t("lang.label.datasavedsuccessfully"),
                text: this.$t("lang.label.emailSettingSuccessfully"),
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              this.$swal({
                type: "error",
                title: this.$t("lang.label.error"),
                text: this.$t("lang.label.error"),
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      });
    },

    processPaymentsData(payments) {
      return payments.map((element) => {
        if (element.has_avatar == 1) {
          let base64 = '';
          base64 = btoa(`usr-${element.user_id}`);
          element.avatar = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
        } else {
          element.avatar = require('@/assets/images/emptyperson.png');
        }

        if (element.coop_price == null) element.coop_price = 0;
        if (element.coop_qty == null) element.coop_qty = 0;

        if (element.coop_price == 0 || element.coop_qty == 0) {
          element.value_cooptation_final = 0;
        } else {
          element.value_cooptation_final = (element.coop_price * element.coop_qty).toFixed(2);
        }

        if (element.abs_meetings == 0) {
          element.abs_commission_total = (0).toFixed(2);
        } else {
          let total_commission;
          total_commission = element.abs_meetings * Number(element.abs_commission_meeting);
          element.abs_commission_total = total_commission.toFixed(2);
        }

        element.commissions = (element.commission_meeting * element.meetings_booked).toFixed(2);

        if (element.current_consistency < 60) {
          element.salary_degrasivity = this.$t("lang.bdr.fixed_salary");
        } else if (element.current_consistency < 80) {
          element.salary_degrasivity = this.$t("lang.bdr.fixed_salary");
        }

        return element;
      });
    },

    getData(allItems = 0) {
      if (
        JSON.stringify(this.filtersPage) != JSON.stringify(this.lastFilterPage)
      ) {
        this.getTotalData();
      }

      const { startDate, endDate } = this.filtersPage.range;
      const startMonth = this.adaptedMonth(startDate);
      const endMonth = this.adaptedMonth(endDate);

      let searchFilter = this.filtersPage;
      searchFilter.cantPerPage = this.pagination.cantPerPage;
      searchFilter.currentPage = this.pagination.currentPage;
      searchFilter.getTotal = 0;
      searchFilter.startDate = startMonth;
      searchFilter.endDate = endMonth;
      searchFilter.bdr_user_id = this.filtersPage.bdr_user_id;
      searchFilter.payment_status_id = this.filtersPage.payment_status_id;
      searchFilter.allItems = allItems;

      if (allItems === 1) {
        this.processingAllItems = true
      } else {
        this.loading = true;
      }


      bookersService.getBookerPayments(searchFilter).then((response) => {
        if (response !== undefined && response.status == 200) {
          if (allItems === 1) {
            this.paymentsAllItems = this.processPaymentsData(response.result.list);
            this.download()
            this.processingAllItems = false
          } else {
            this.payments = this.processPaymentsData(response.result.list);
            this.lastFilterPage = JSON.parse(JSON.stringify(this.filtersPage));
            this.loading = false;
          }
        }
      });
    },

    getTotalData() {
      const startMonth = this.adaptedMonth(this.filtersPage.range.startDate);
      const endMonth = this.adaptedMonth(this.filtersPage.range.endDate);

      let searchFilter = this.filtersPage;
      searchFilter.cantPerPage = this.pagination.cantPerPage;
      searchFilter.currentPage = this.pagination.currentPage;
      searchFilter.getTotal = 1;
      searchFilter.startDate = startMonth;
      searchFilter.endDate = endMonth;
      searchFilter.bdr_user_id = this.filtersPage.bdr_user_id;

      bookersService.getBookerPayments(searchFilter).then((response) => {
        this.total = response.result.total;
        if (response.result.stats.total_final_salary) {
          this.salaryTotal = response.result.stats.total_final_salary;
        } else {
          this.salaryTotal = 0;
        }
      });
    },

    filter(event) {
      this.filters = event;
      this.loadOrders(this.orderStatus, this.filters);
    },
    goToUser(user_id) {
      if (this.currentUser.role_id == 1 || this.isBookerManager) {
        window.open("/users/" + user_id, "_blank");
      }
      return false;
    },
  },
};
</script>
